import DollarCircleIconSolid from '@/components/icons/DollarCircleIconSolid';
import MoneyReceiveCircleIconSolid from '@/components/icons/MoneyReceiveCircleIconSolid';
import MoneySendCircleIconSolid from '@/components/icons/MoneySendCircleIconSolid';
import { t } from 'i18next';

const getAnalyticsInfoBlockConfig = (label: 'revenue' | 'expenses' | 'income') => {
	switch (label) {
		case 'revenue':
			return {
				label: t('main.finances.components.analytics.components.revenue.title'),
				icon: MoneyReceiveCircleIconSolid,
				iconColor: 'fill-warning-1000',
				iconBgColor: 'bg-warning-100',
			};
		case 'expenses':
			return {
				label: t('main.finances.components.analytics.components.expenses.title'),
				icon: MoneySendCircleIconSolid,
				iconColor: 'fill-error-1000',
				iconBgColor: 'bg-error-100',
			};
		case 'income':
			return {
				label: t('main.finances.components.analytics.components.income.title'),
				icon: DollarCircleIconSolid,
				iconColor: 'fill-success-1000',
				iconBgColor: 'bg-success-100',
			};		
	}
};

const getBalanceElementConfig = (label: 'property' | 'otherService') => {
	switch (label) {
		case 'property':
			return {
				title: t('main.transactions.type.property'),
				iconColor: 'fill-success-1000',
				iconBgColor: 'bg-success-100',
			};
			case 'otherService':
			return {
				title: t('main.transactions.type.otherServices'),
				iconColor: 'fill-info-1000',
				iconBgColor: 'bg-info-100',
			};
	}
};

export const FinancesUtils = {
	getAnalyticsInfoBlockConfig,
	getBalanceElementConfig,	
};
